import { http, HttpResponse } from 'msw';
import { apiUrl } from '../apiUrl';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { userSettings } from '../../data/userInfo';

export const userSettingsQuery = http.get(apiUrl(AccountApiPaths.userSettings), () =>
    HttpResponse.json({ userSettings })
);
export const userSettingsMutation = http.post(apiUrl(AccountApiPaths.userSettings), () => HttpResponse.json());

export const userSettingsHandlers = [userSettingsQuery, userSettingsMutation];
